import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import '../Style/Home.css';
import AppNavbar from "../Navbar/Navbar";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { API_URLS } from "../Utils/Constants";

const Home = () => {
    const [usuario, setUsuario] = useState('');
    const [rol, setRol] = useState('');
    const [campaigns, setCampaigns] = useState([]);
    const navigate = useNavigate();

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
        } else {
            try {
                const url = `${API_URLS.BASE_PATH}/api/campaigns`;

                const decoded = jwt_decode(token);
                setUsuario(decoded.username || 'Usuario');
                setRol(decoded.rol);

                const fetchCampaigns = async () => {
                    const response = await fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `${token}`,
                        },
                    });

                    if (response.ok) {
                        const data = await response.json();
                        setCampaigns(data);
                    } else if (response.status === 403 || response.status === 401) {
                        console.error('Token invalido o expirado');
                        localStorage.removeItem('token');
                        navigate('/login');
                    } else {
                        console.error('Failed to fetch campaigns', response.statusText);
                    }
                };

                fetchCampaigns();
            } catch (error) {
                console.error('Error al decodificar el token', error);
                navigate('/login');
            }
        }
    }, [navigate]);

    const handleModify = (id) => {
        navigate(`/edit-campaign/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
            }

            const response = await fetch(`${API_URLS.BASE_PATH}/api/campaign/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                },
            });

            if (response.status === 200 || response.status === 204) {
                window.location.reload();
            } else if (response.status === 403 || response.status === 401) {
                console.error('Token invalido o expirado');
                localStorage.removeItem('token');
                navigate('/login');
            } else {
                console.error('Failed to delete campaign', response.statusText);
            }
        } catch (error) {
            console.error('Error al eliminar la campaña', error);
        }


    }

    const handleView = (id) => {
        navigate(`/campaign/${id}`);
    };

    const handleAddCandidate = (id) => {
        navigate(`/add-candidate/${id}`);
    };

    const handleAddCampaign = () => {
        navigate('/add-campaign');
    };

    return (
        <div className="home-container">
            <AppNavbar />

            <h2 className="home-title">Campañas Actuales</h2>

            <br/>

            {rol === 'ADMIN' && (
                <Button
                    onClick={handleAddCampaign}
                    variant="success"
                    className="floating-button"> +
                </Button>
            )}

            <div className="campaign-grid">
                {campaigns.map((campaign) => (
                    <Card key={campaign._id} className={`campaign-card ${rol === 'ADMIN' ? 'admin-card' : ''}`}>
                        <div className="icon-container">
                            <i className="bi bi-archive-fill icon-style"></i>
                        </div>
                        <Card.Body>
                            <Card.Title>{campaign.title}</Card.Title>
                            <div className="button-group">

                                <Card.Text>{truncateText(campaign.description, 105)}</Card.Text>
                                {rol === 'ADMIN' && (
                                    <Button onClick={() => handleAddCandidate(campaign._id)} variant="success">
                                        Agregar Candidatos
                                    </Button>
                                )}
                                <br/>
                                <Button onClick={() => handleView(campaign._id)} variant="primary">Ver Detalles</Button>

                                {rol === 'ADMIN' && (
                                    <>
                                        <div className="delete-overlay">
                                            <Button onClick={() => handleDelete(campaign._id)} variant="danger">
                                                <i className="bi bi-x"></i>
                                            </Button>
                                        </div>

                                        <div className="modify-overlay">
                                            <Button onClick={() => handleModify(campaign._id)} variant="warning">
                                                <i className="bi bi-pencil-fill"></i>
                                            </Button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                ))}
            </div>
        </div>
    );
}

export default Home;
